import styled from "styled-components";

export const HeaderContainer = styled.header`
  width: 100%;
  height: 150px;

  display: flex;

  div {
    width: 100%;
    display: flex;
    flex-direction: column;

    .auth-header {
      height: 50px;
    }
  }
`;

export const HeaderStyled = styled.header`
  width: 100%;
  height: 100px;

  display: flex;
  justify-content: space-around;
  position: fixed;
  align-items: center;

  background: ${({ theme }) => theme.headerBackground};

  img {
    width: 100px;
    background: #fff;
    z-index: 99999999;
  }

  /*   @media (max-width: 450px) {
    img {
      transition: 1.8s all;
      width: 200px;
    }
  } */
`;

export const NavbarStyled = styled.nav`
  ul {
    display: flex;
    justify-content: center;
    align-itens: center;
    list-style-type: none;
    text-align: center;
  }
`;

export const NavbarLinkStyled = styled.a`
  font: 700 1.2rem "Roboto", sans-serif;
  text-decoration: none;
  line-height: 60px;
  color: ${({ theme }) => theme.navbarText};

  padding-right: 30px;
  border: 0;

  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 750px) {
    display: none;
  }
`;

export const NavbarButtonStyled = styled.nav`
  font: 700 1.2rem "Roboto", sans-serif;
  line-height: 60px;
  color: ${({ theme }) => theme.navbarText};

  padding-right: 30px;
  border: 0;

  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 750px) {
    display: none;
  }
`;
export const NavbarButtonLoginStyled = styled.nav`
  font: 700 1.2rem "Roboto", sans-serif;

  color: #000;
  background: #fff;
  text-aling: center;

  padding: 16px 42px;
  border: 1px solid #a2a2a2;
  border-radius: 5px;

  cursor: pointer;

  &:hover {
    transition: 1s all;
    box-shadow: 0px 0px 10px 5px rgba(255, 255, 255, 1);
  }

  @media (max-width: 750px) {
    display: none;
  }
`;

export const ButtonMenuToggle = styled.button`
  display: block;
  background-color: transparent;
  border: none;
  cursor: pointer;

  .menu-icon {
    display: block;
    width: 20px;
    height: 3px;
    background-color: #fff;
    position: relative;
  }

  .menu-icon::before {
    top: -6px;
  }

  .menu-icon::after {
    bottom: -6px;
  }

  .menu-icon::before,
  .menu-icon::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-color: #fff;
    position: absolute;
    left: 0;
    transition: transform 0.3s ease-in-out;
  }

  @media (min-width: 750px) {
    display: none;
  }
`;

export const Modal = styled.div`
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;

  background-color: ${({ theme }) => theme.modalBackground};
  padding: 30px;

  .header-mobile {
    position: absolute;
    top: 0px;

    /*     display: flex;
    flex-direction: row;
    justify-content: space-between;

    p {
      background-color: #fff;
      font: 700 2.5rem "Work Sans", sans-serif;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      margin-left: 30px;
    } */

    button {
      border: none;
      margin-right: 30px;
      position: absolute;
      top: 40px;
      right: 40px;

      font: 700 1.2rem "Roboto", sans-serif;
      background: ${({ theme }) => theme.modalBackground};
      color: ${({ theme }) => theme.modalText};

      cursor: pointer;
      z-index: 1001;
    }
  }

  div {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
`;

export const NavbarModalStyled = styled.nav`
  width: 100%;
  padding-bottom: 10px;

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
  }

  li {
    border-bottom: 1px solid gray;
    display: flex;
    flex-direction: flex-start;
    align-items: center;
    padding: 15px;
  }

  a {
    text-decoration: none;
    font: 500 1rem "Roboto", sans-serif;
    color: ${({ theme }) => theme.modalText};
    line-height: 32px;

    border: 0;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  button {
    font: 500 1rem "Roboto", sans-serif;
    color: ${({ theme }) => theme.modalText};
    line-height: 32px;

    background: transparent;
    border: 0;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .login-mobile {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 0;
    margin-top: 40px;
    padding: 0;
  }

  .login-mobile button {
    width: 100%;
    color: ${({ theme }) => theme.modalButtonText};
    padding: 12px 0px;
    border: 2px solid ${({ theme }) => theme.modalButtonText};
    background: ${({ theme }) => theme.modalButtonBackground};
  }

  .login-mobile:active {
    transform: translateY(4px);
  }
`;

export const DropDown = styled.ul`
  transition: 3s all;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100px;
  width: auto;
  background-color: rgba(0, 0, 0, 0.7);

  padding: 10px;
  list-style: none;
  margin: 0;
  li {
    margin-bottom: 5px;
    &:hover {
      transition: 0.7s all;
      background-color: #222324;
    }
  }

  button {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 8px;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid #4cd964;
    font: 500 1rem "Roboto", sans-serif;
    color: #fff;

    cursor: pointer;
  }
`;
